import { render } from "./VTreatmentDaysAndShifts.vue?vue&type=template&id=1af63598"
import script from "./VTreatmentDaysAndShifts.vue?vue&type=script&lang=js"
export * from "./VTreatmentDaysAndShifts.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bookdialysis/bookdialysis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__